import React from "react";
import { Grid, Typography, Container, Box } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import BuildIcon from "@mui/icons-material/Build";
import ComputerIcon from "@mui/icons-material/Computer";
import BarChartIcon from "@mui/icons-material/BarChart";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloudIcon from "@mui/icons-material/Cloud";
import MeassageIcon from "@mui/icons-material/Message";
import CancelIcon from "@mui/icons-material/Cancel";
import calculateSpacing from "./calculateSpacing";
import useMediaQuery from "@mui/material/useMediaQuery";
import { withTheme } from "@mui/styles";
import FeatureCard from "./FeatureCard";
import TextIconCard from "./TextIconCard";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGavel, faPeopleRoof, faShieldHalved, faPersonMilitaryRifle, faPrescriptionBottleMedical, faBrain } from '@fortawesome/free-solid-svg-icons'
import useWidth from "../../../shared/functions/useWidth";

const iconSize = 30;

const infoBlurbs = [
  {
    headline: "First Appearance at Jail",
    text: "If arrested and charged with a felony in Henry County, you will see one of our attorneys at the jail, 6 days a week. We will address bond, the charges, and next steps in the process."
  },
  {
    headline: "Preliminary Hearing",
    text: "A hearing in front of a Magistrate Court Judge to determine if the State has proven probable cause to bind your case over to Superior Court. From here, the case goes to Superior Court."
  },
  {
    headline: "Bond",
    text: "Our attorneys will work to get the most reasonable bond possible. Some cases require a statutory bond hearing, which will be scheduled within 30 days of notice to Superior Court (notice must be within 48 hours of arrest, and is usually sent out the same day as First Appearance). We cannot guarantee that the judge will grant a bond, but we DO guarantee the best representation and effort to get one."
  }
]

const courtBlurbs = [
  {
    headline: "Veteran's Treatment Court",
    text: "Helps Henry County military veterans involved in the judicial system obtain outpatient treatment.",
    variant: "body1",
    icon: <FontAwesomeIcon icon={faPersonMilitaryRifle} style={{ fontSize: 64 }} />,
  },
  {
    headline: "Drug Court",
    text: "Helps Henry County citizens suffering primarily from drug addiction get intensive substance abuse treatment.",
    variant: "body1",
    icon: <FontAwesomeIcon icon={faPrescriptionBottleMedical} style={{ fontSize: 64 }} />
  },
  {
    headline: "Mental Health Court",
    text: "Helps Henry County citizens struggling primarily with mental health diagnoses receive focused, personalized treatment.",
    variant: "body1",
    icon: <FontAwesomeIcon icon={faBrain} style={{ fontSize: 64 }} />
  }
]

const questionBlurbs = [
  {
    headline: "How long does the process take?",
    text: "The short answer is, it depends. After a case goes to Superior Court, it is in the hands of the prosecutor's office. It can take several months to get to the next steps in the process, and sometimes over a year or more before case resolution. The entire time, WE are working to defend our clients with excellent representation!"
  },
  {
    headline: "What if I can't afford my bond?",
    text: "If your bond has been set but you cannot afford it, speak with one of our attorneys. We will do our best to get an affordable bond so that you can get out of jail."
  },
  {
    headline: "What if I need drug or mental health treatment?",
    text: "Our attorneys know of many resources to help you with substance abuse and mental health issues and will work with you to get appropriate treatment."
  }
]


const whoAreWeSection = [
  {
    color: "#00C853",
    headline: "",
    text: "The Flint Judicial Circuit Office of the Public Defender has an incredible team, made up of people who dedicate their lives to helping others. In addition to our attorneys, who are the best in Georgia, we have a team of investigators who make sure that all clients’ allegations are fully and accurately investigated.",
    icon: <FontAwesomeIcon icon={faShieldHalved} style={{ fontSize: 64 }} />,
    mdDelay: "0",
    smDelay: "0",
  },

  {
    color: "#00C853",
    headline: "blah",
    text: "Additionally, we have a team of Legal Assistants who support our attorneys and make sure our clients, and their loved ones, have the information they need. Importantly, we have a Mitigation Specialist who ensures that those with mental health diagnoses are given the medical attention they need, as well as working specifically with, and telling the stories of, those facing the most serious charges.",
    icon: <FontAwesomeIcon icon={faPeopleRoof} style={{ fontSize: 64 }} />,
    mdDelay: "0",
    smDelay: "0",
  },

  {
    color: "#00C853",
    headline: "blah",
    text: "Our amazing team of advocates care deeply about our clients, work relentlessly toward true justice and have a well-earned reputation of excellence.",
    icon: <FontAwesomeIcon icon={faGavel} style={{ fontSize: 64 }} />,
    mdDelay: "0",
    smDelay: "0",
  },

]

const attorneys = [
  {
    color: "#00C853",
    headline: "Jennifer L. Lewis - Circuit Public Defender",
    text: "Attorney Jennifer L. Lewis has practiced law in Georgia since 2006, although she likes to say that she has been a Public Defender her entire life. A graduate of Golden Gate University School of Law, Jen is honored that Public Defense is her life’s calling and she is extremely proud of the excellent work that she, and her office, does every day. She has tried many cases and has saved countless lives in her fight for justice, equality and fairness for her clients. She has significant experience helping those with mental health diagnoses, helping Spanish-speakers, and training attorneys. Jen has professional relationships with several law schools and immensely enjoys teaching trial techniques, including at Emory University School of Law annually. Additionally, she is a NITA certified instructor and has spoken nationally on effective leadership. She and her office practice holistic, client-centered public defense; they endeavor to solve the underlying issues that bring people to them, so that they can have a better future.",
    icon: <BuildIcon style={{ fontSize: iconSize }} />,
    mdDelay: "0",
    smDelay: "0",
  },
  {
    color: "#6200EA",
    headline: "Daniel Wells - Director of Legal Strategy",
    text: "As the Director of Legal Strategy, Attorney Danny Wells assists attorneys throughout the office with legal strategy, motions practice, and legal research. He also handles cases before the Georgia Appellate Courts, including client advocacy, writing appellate briefs, and presenting oral argument. Additionally, he tries cases with complex or unique issues. A leader in the office, Danny has practiced law since 2015 after graduating from the University of Michigan Law School; he is very well-respected for his brilliant mind and analytical skills, often responding to calls for help by attorneys throughout Georgia.",
    icon: <CalendarTodayIcon style={{ fontSize: iconSize }} />,
    mdDelay: "200",
    smDelay: "200",
  },
  {
    color: "#6200EA",
    headline: "Lauren Thrasher - Director of Trial Strategy",
    text: "Attorney Lauren Thrasher serves as our Director of Trial Strategy. Drawing on extensive courtroom experience and a deep commitment to Public Defense, she provides guidance and strategic support to attorneys in all aspects of trial preparation, including work before and during trials. A 2015 graduate of Emory University School of Law, she remains connected to the academic community as an Adjunct Professor at Emory Law, where she teaches Trial Advocacy. In addition to her work in Georgia, Lauren is a Program Director with the National Institute for Trial Advocacy (NITA), teaching litigation skills both nationally and internationally. She is a well-respected leader, bringing a passion for mentorship, excellence in advocacy and a global perspective to advancing justice through skilled legal representation for those who need it the most. ",
    icon: <CalendarTodayIcon style={{ fontSize: iconSize }} />,
    mdDelay: "200",
    smDelay: "200",
  },
]

const features = [
  {
    color: "#00C853",
    headline: "Feature 1",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <BuildIcon style={{ fontSize: iconSize }} />,
    mdDelay: "0",
    smDelay: "0",
  },
  {
    color: "#6200EA",
    headline: "Feature 2",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <CalendarTodayIcon style={{ fontSize: iconSize }} />,
    mdDelay: "200",
    smDelay: "200",
  },
  {
    color: "#0091EA",
    headline: "Feature 3",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <MeassageIcon style={{ fontSize: iconSize }} />,
    mdDelay: "400",
    smDelay: "0",
  },
  {
    color: "#d50000",
    headline: "Feature 4",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <ComputerIcon style={{ fontSize: iconSize }} />,
    mdDelay: "0",
    smDelay: "200",
  },
  {
    color: "#DD2C00",
    headline: "Feature 5",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <BarChartIcon style={{ fontSize: iconSize }} />,
    mdDelay: "200",
    smDelay: "0",
  },
  {
    color: "#64DD17",
    headline: "Feature 6",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <HeadsetMicIcon style={{ fontSize: iconSize }} />,
    mdDelay: "400",
    smDelay: "200",
  },
  {
    color: "#304FFE",
    headline: "Feature 7",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <CloudIcon style={{ fontSize: iconSize }} />,
    mdDelay: "0",
    smDelay: "0",
  },
  {
    color: "#C51162",
    headline: "Feature 8",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <CodeIcon style={{ fontSize: iconSize }} />,
    mdDelay: "200",
    smDelay: "200",
  },
  {
    color: "#00B8D4",
    headline: "Feature 9",
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
    icon: <CancelIcon style={{ fontSize: iconSize }} />,
    mdDelay: "400",
    smDelay: "0",
  },
];

function FeatureSection(props) {
  const { theme } = props;
  const width = useWidth();
  const isWidthUpMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <div style={{ backgroundColor: "#FFFFFF" }}>
      <div className="container-fluid lg-p-top">

        <Typography variant="h3" align="center" gutterBottom sx={{ mb: 4 }}>
          Our Office
        </Typography>
        <div className="container-fluid">
          <Grid container spacing={calculateSpacing(width, theme)}>
            {attorneys.map((element) => (
              <Grid
                item
                xs={12}
                md={12}
                data-aos="zoom-in-up"
                data-aos-delay={isWidthUpMd ? element.mdDelay : element.smDelay}
                key={element.headline}
                sx={{
                  display: 'flex',               // <-- make it a flex container
                  flexDirection: 'column',       // <-- stack children vertically
                  alignItems: 'center',          // <-- center horizontally
                  justifyContent: 'center',      // <-- center vertically
                  minHeight: '60vh',             // <-- give it some height to work with
                  textAlign: 'center',
                }}
              >
                <FeatureCard
                  Icon={element.icon}
                  color={element.color}
                  headline={element.headline}
                  text={element.text}
                />
              </Grid>
            ))}
          </Grid>
        </div>

        <Typography variant="h3" align="center" gutterBottom sx={{ mt: 6 }}>
          Who Are We?
        </Typography>

        {
          whoAreWeSection.map((element) => (
            <TextIconCard
              Icon={element.icon}
              color={element.color}
              headline={element.headline}
              text={element.text}
            />
          ))
        }

        <HelpfulInfo infoBlurbs={infoBlurbs} />

        <AccountabilityCourts courtBlurbs={courtBlurbs} />

        <FAQs questionBlurbs={questionBlurbs} />

        <InternshipProgram />


      </div>
    </div>
  );
}

function HelpfulInfo({ infoBlurbs }) {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ mt: 6, mb: 6 }}
      >
        Helpful Information
      </Typography>
      <Grid container spacing={4}>
        {infoBlurbs.map((blurb, idx) => (
          <Grid item xs={12} sm={4} key={idx}>
            <Box sx={{ pt: 4 }}>
              <Typography variant="h5" paragraph align="center">
                {blurb.headline}
              </Typography>
              <Typography variant="body1" color="textSecondary" align="center">
                {blurb.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

function AccountabilityCourts({ courtBlurbs }) {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ mt: 6, mb: 6 }}
      >
        Accountability Courts
      </Typography>
      <Typography variant="h6" color="textSecondary" align="center">
        Alternatives to incarceration, with a focus on treatment and accountability. Our goal is to change lives for the better and produce law abiding, gainfully employed members of society.
      </Typography>
      <Grid container spacing={4}>
        {courtBlurbs.map((blurb, idx) => (
          <Grid item xs={12} sm={4} key={idx}>
            <Box sx={{ pt: 4 }}>
              <Typography variant="h5" paragraph align="center">
                {blurb.headline}
              </Typography>
              <TextIconCard
                Icon={blurb.icon}
                color={blurb.color}
                headline={blurb.headline}
                text={blurb.text}
                variant={blurb.variant}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{ mt: 3, mb: 3 }}
      >
        Pre-Trial Diversion Program
      </Typography>
      <Typography variant="h6" color="textSecondary" align="center">
        For first time offenders who have posted bond, this program allows our clients to perform community service, pay certain fees, take classes and stay drug free in order to dismiss the case.
      </Typography>
    </Container>
  );
}

function FAQs({ questionBlurbs }) {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ mt: 6, mb: 6 }}
      >
        Frequently Asked Questions
      </Typography>
      <Grid container spacing={4}>
        {questionBlurbs.map((blurb, idx) => (
          <Grid item xs={12} sm={4} key={idx}>
            <Box sx={{ pt: 4 }}>
              <Typography variant="h5" paragraph align="center">
                {blurb.headline}
              </Typography>
              <Typography variant="body1" color="textSecondary" align="center">
                {blurb.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

function InternshipProgram() {
  return (
    <Container maxWidth="lg">
      <Typography
        variant="h3"
        align="center"
      >
        Internship/Externship Program
      </Typography>
      <Grid container sx={{
                  display: 'flex',               
                  flexDirection: 'column',       
                  alignItems: 'center',          
                  justifyContent: 'center',      
                  minHeight: '35vh',             
                  textAlign: 'center',
                }}>
          <Typography variant="h6" align="center">
            We have an excellent internship/externship program for law students, as well as for high school and college students in areas of
            Law, Social Work, Legal Assistance and Paralegal Studies. It is a hands-on, immersive, expansive, and
            incredible experience! Interns and externs have opportunities to observe, and participate in,
            the important work of Public Defense in Superior Court, Juvenile Court, Magistrate Court, and
            Accountability Courts. With a Student Practice Certificate, law student interns and externs
            can actually handle cases and argue in Court, under the supportive supervision of their trial team.
            Please reach out to Circuit Public Defender Jennifer L. Lewis to talk about joining our amazing
            team of advocates!
          </Typography>
      </Grid>
    </Container>
  );
}

FeatureSection.propTypes = {};

export default withTheme(FeatureSection);
